/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Refund_BodyInputs */

const en_directory_ai_tools_trust_refund_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Refund_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a render fails or is blocked, the credits go straight back.`)
};

const zh_directory_ai_tools_trust_refund_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Refund_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成失败或被拦截时，积分会立刻退回。`)
};

/**
* | output |
* | --- |
* | "If a render fails or is blocked, the credits go straight back." |
*
* @param {Directory_Ai_Tools_Trust_Refund_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_refund_body = /** @type {((inputs?: Directory_Ai_Tools_Trust_Refund_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Refund_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_refund_body(inputs)
	return zh_directory_ai_tools_trust_refund_body(inputs)
});
export { directory_ai_tools_trust_refund_body as "directory.ai_tools.trust.refund_body" }